import { Table } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { viewLead, getDynamicFields } from '../../../redux/actions/Files.action';
import { useParams } from 'react-router-dom';

export default function FileView() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const viewFile = useSelector((state) => state.files);
    
    const data = viewFile?.viewLead?.data?.PatientData;
    const dynamicFields = viewFile?.getDynamicFields?.data;
    // const 
    useEffect(() => {
        if (id) {
            dispatch(viewLead(id));
            dispatch(getDynamicFields(id));
        }
    }, [dispatch, id]);
    const formatTime = (dateString) => {
    const date = new Date(dateString);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours || 12;
    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutesFormatted} ${ampm}`;
  };
    const formatDynamicValue = (field) => {
        if (!field.value) return 'N/A'; // Handle null or undefined values

        switch (field.inputType) {
            case 'date':
                try {
                    return new Date(field.value).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    });
                } catch (error) {
                    return field.value; // Fallback to raw value if date is invalid
                }
            case 'checkbox':
                return field.value.split(',').join(', '); // Format comma-separated values
            default:
                return field.value; // Return as-is for text, number, select, radio, textarea
        }
    };
    return (
        <div className='mt-[100px]'>
            <div className="mt-[50px]">
                {data ? (
                    <div className='flex items-start'>
                        <Table cellPadding={5}>
                            <caption className='caption-top font-bold'>User Details:</caption>
                            <tbody>
                                <tr>
                                    <td className='text-gray-500 font-medium'>First Name</td>
                                    <td style={{ width: '50px' }}>:</td>
                                    <td>{data?.firstName}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Middle Name</td>
                                    <td>:</td>
                                    <td>{data?.middleName}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Last Name</td>
                                    <td>:</td>
                                    <td>{data?.lastName}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Branch</td>
                                    <td>:</td>
                                    <td>{data?.branch}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Mobile Number</td>
                                    <td>:</td>
                                    <td>{data?.phoneNumber}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Gender</td>
                                    <td>:</td>
                                    <td>{data?.gender}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Date Of Birth</td>
                                    <td>:</td>
                                    <td>{data?.dateOfBirth ? new Date(data?.dateOfBirth).toLocaleDateString('en-GB') : '-'}</td>
                                </tr>
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Country</td>
                                    <td>:</td>
                                    <td>{data?.country}</td>
                                </tr> */}
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>State</td>
                                    <td>:</td>
                                    <td>{data?.state}</td>
                                </tr> */}
                                <tr>
                                    <td className='text-gray-500 font-medium'>City</td>
                                    <td>:</td>
                                    <td>{data?.city}</td>
                                </tr>
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Area</td>
                                    <td>:</td>
                                    <td>{data?.area}</td>
                                </tr> */}
                                <tr>
                                    <td className='text-gray-500 font-medium'>Lead Received On</td>
                                    <td>:</td>
                                    <td>{data?.leadReceived}</td>
                                </tr>
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Problem</td>
                                    <td>:</td>
                                    <td>{data?.problem}</td>
                                </tr> */}
                                <tr>
                                    <td className='text-gray-500 font-medium'>Lead Status</td>
                                    <td>:</td>
                                    <td>{data?.leadStatus}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Campaign</td>
                                    <td>:</td>
                                    <td>{data?.campaign?.[0]?.cname}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Campaign Detail</td>
                                    <td>:</td>
                                    <td>{data?.campaign?.[0]?.description}</td>
                                </tr>
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Reference</td>
                                    <td>:</td>
                                    <td>{data?.reference?.[0]?.doctorDetail || data?.reference?.[0]?.personDetail || ''}</td>
                                </tr> */}
                                <tr>
                                    <td className='text-gray-500 font-medium'>Next Follow-up Date</td>
                                    <td>:</td>
                                    <td>{new Date(data?.nextFollowUpDate).toLocaleDateString('en-GB')}</td>
                                </tr>
                                {dynamicFields?.data?.length > 0 &&
                                    dynamicFields?.data?.map((field, index) => (
                                        <tr key={index}>
                                            <td className="text-gray-500 font-medium">
                                                {field.label}
                                            </td>
                                            <td>:</td>
                                            <td>{formatDynamicValue(field)}</td>
                                        </tr>
                                    ))}
                                {(!dynamicFields?.data || dynamicFields?.data?.length === 0) && (
                                    <tr>
                                        <td colSpan="3" className="text-center py-4">
                                            No dynamic fields available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>

                        <div className="vr me-4"></div>

                        <Table cellPadding={5}>
                            <caption className='caption-top font-bold'>Call Time:</caption>
                            <tbody>
                                <tr>
                                    <td className='text-gray-500 font-medium'>From</td>
                                    <td>:</td>
                                    <td>{data?.from ? formatTime(data?.from) : ''}</td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>To</td>
                                    <td>:</td>
                                    <td>{data?.to ? formatTime(data?.to) : ''}</td>
                                </tr>
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Nationality</td>
                                    <td>:</td>
                                    <td>{data?.nationality}</td>
                                </tr> */}
                                <tr>
                                    <td className='text-gray-500 font-medium'>Lead Assigned</td>
                                    <td>:</td>
                                    <td>{data?.counselorAssign?.name}</td>
                                </tr>
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Occupation</td>
                                    <td>:</td>
                                    <td>{data?.occupation}</td>
                                </tr> */}
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Email</td>
                                    <td>:</td>
                                    <td>{data?.email}</td>
                                </tr> */}
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Address</td>
                                    <td>:</td>
                                    <td>{data?.address}</td>
                                </tr> */}
                                {/* <tr>
                                    <td className='text-gray-500 font-medium'>Pincode</td>
                                    <td>:</td>
                                    <td>{data?.pincode}</td>
                                </tr> */}
                                <tr>
                                    <td className='text-gray-500 font-medium'>Photo</td>
                                    <td>:</td>
                                    <td><img src={data?.photo} alt="photo" className='w-[70px]' /></td>
                                </tr>
                                <tr>
                                    <td className='text-gray-500 font-medium'>Lead Follow-up Remark</td>
                                    <td>:</td>
                                    <td>{data?.leadFollowUpRemark}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <p>Loading data...</p>
                )}
            </div>
        </div>
    );
}
